import { parseUnits } from "ethers/lib/utils"
import { BigNumber } from "@ethersproject/bignumber"
import { SWAP_TYPES } from "."

export const SWAP_CONTRACT_GAS_ESTIMATES_MAP = {
  [SWAP_TYPES.INVALID]: BigNumber.from("999999999"), // 999,999,999
  [SWAP_TYPES.DIRECT]: BigNumber.from("200000"), // 157,807
  [SWAP_TYPES.WRAPPED]: BigNumber.from("400000"),
  // [SWAP_TYPES.TOKEN_TO_TOKEN]: BigNumber.from("2000000"), // 1,676,837
  // [SWAP_TYPES.TOKEN_TO_SYNTH]: BigNumber.from("2000000"), // 1,655,502
  // [SWAP_TYPES.SYNTH_TO_TOKEN]: BigNumber.from("1500000"), // 1,153,654
  // [SWAP_TYPES.SYNTH_TO_SYNTH]: BigNumber.from("700000"), // 681,128 // TODO: https://github.com/ferro-finance/ferro-frontend/issues/471
  addLiquidity: BigNumber.from("400000"), // 386,555
  removeLiquidityImbalance: BigNumber.from("350000"), // 318,231
  removeLiquidityOneToken: BigNumber.from("250000"), // 232,947
  migrate: BigNumber.from("650000"), // 619,126
  virtualSwapSettleOrWithdraw: BigNumber.from("400000"),
}

// Gas options
export const XFER_GAS_PRICE = parseUnits("10000", "gwei")
// farm v2 not using in prod atm, can check the POOLS_MAP in src/constants/index.ts
export const FARMV2_GAS_PRICE = parseUnits("10000", "gwei")
export const FARMV2_GAS_LIMIT = 1000000
